<!--
  App

  還原自 index.pretty.js L100（原始 production bundle，2022-06 build）。
  render function 已轉回 template。
-->

<template>
  <router-view />
</template>

<script>
export default {
  name: 'App'
}
</script>
